import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=a8050c24&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=js&"
export * from "./Step.vue?vue&type=script&lang=js&"
import style1 from "./Step.vue?vue&type=style&index=1&id=a8050c24&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8050c24",
  null
  
)

export default component.exports